import React, { useRef, useState, useEffect } from "react"
import { Props } from "./Tabs.interface"
import Tab from "./Tab"

import * as s from "./Tabs.module.scss"

export const Tabs = ({
  controlName,
  children,
  className,
  controlledTab,
  onClick,
  onTabClick,
}: Props) => {
  const [activeTab, setActiveTab] = useState(null)
  const tabList = useRef([])
  /*eslint-disable*/
  const onClickTabItem = j => {
    onTabClick && onTabClick(j)
    setActiveTab(prev => {
      return j
    })
  }
  /*eslint-enable*/

  useEffect(() => {
    if (controlledTab) {
      tabList.current.childNodes[0].click()
    }
  }, [controlledTab])

  return (
    <div
      onClick={onClick}
      className={`${className} ${activeTab && s.tabs__selectionMade} ${
        activeTab === null && s.tabs__noSelectionMade
      }`}
    >
      <div ref={tabList} className={s.tabs__list} role="tablist">
        {children &&
          children.map((child, idx) => {
            const { label, controlName } = child.props
            return (
              <React.Fragment key={idx}>
                <Tab
                  activeTab={activeTab}
                  tabId={idx}
                  label={label}
                  controlName={controlName}
                  onClick={() => onClickTabItem(idx)}
                />
              </React.Fragment>
            )
          })}
      </div>
      {children &&
        children.map((child, i) => {
          const isActive = i === activeTab
          return (
            <div
              key={i}
              id={`tabpanel-${i}`}
              role="tabpanel"
              aria-labelledby={`${controlName}-tabpanel-${i}`}
              className={s.tabs__tabpanel}
              hidden={!isActive}
            >
              {child.props.children}
            </div>
          )
        })}
    </div>
  )
}
